export default __webpack_public_path__ + "static/media/office1-after1-768w.129c6cf7.avif";